import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleStartBuilding = () => {
    navigate('/showcase');
  };

  const handleMarlaClick = (marlaType) => {
    navigate(`/showcase?filter=${marlaType}`);
  };

  // Check if 5 Marla or 10 Marla filter is active
  const searchParams = new URLSearchParams(location.search);
  const activeFilter = searchParams.get('filter');
  const is5MarlaActive = activeFilter === '5-marla' || (location.pathname === '/showcase' && activeFilter === '5-marla');
  const is10MarlaActive = activeFilter === '10-marla' || (location.pathname === '/showcase' && activeFilter === '10-marla');

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-link">
          <div className="navbar-logo">
            <span className="logo-text">Classic Villas</span>
          </div>
        </Link>
        
        <div className="navbar-links">
          <button 
            onClick={() => handleMarlaClick('5-marla')} 
            className={`nav-link nav-link-button ${is5MarlaActive ? 'active' : ''}`}
          >
            5 Marla
          </button>
          <button 
            onClick={() => handleMarlaClick('10-marla')} 
            className={`nav-link nav-link-button ${is10MarlaActive ? 'active' : ''}`}
          >
            10 Marla
          </button>
        </div>
        
        <button className="navbar-signup-btn" onClick={handleStartBuilding}>
          Start Building
        </button>
      </div>
    </nav>
  );
};

export default Navbar;

